import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./order-detail.scss";

const orderDetails = {
  "SB-10084": {
    orderNo: "SB-10084",
    vendor: "Hikari House",
    customer: "Channie",
    phone: "012-3456789",
    email: "channie@example.com",
    status: "Collectible",
    paymentStatus: "Paid",
    paymentMethod: "Fiuu FPX",
    collectionTime: "Today, 6:30 PM",
    orderTime: "28 Jun 2026, 5:58 PM",
    amount: "RM18.90",
    subtotal: "RM17.90",
    serviceFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Hikari House - Kuching Central",
    pickupCode: "8421",
    remarks: "Customer will collect before 6:45 PM.",
    items: [
      { name: "Chicken Katsu Bento", qty: 1, price: "RM12.90", total: "RM12.90" },
      { name: "Matcha Latte", qty: 1, price: "RM5.00", total: "RM5.00" },
    ],
    timeline: [
      ["Order Created", "28 Jun 2026, 5:58 PM"],
      ["Payment Successful", "28 Jun 2026, 6:01 PM"],
      ["Ready for Collection", "28 Jun 2026, 6:20 PM"],
    ],
  },
  "SB-10083": {
    orderNo: "SB-10083",
    vendor: "Green Bowl",
    customer: "Daniel",
    phone: "011-2233445",
    email: "daniel@example.com",
    status: "Paid",
    paymentStatus: "Paid",
    paymentMethod: "Fiuu Card",
    collectionTime: "Today, 7:00 PM",
    orderTime: "28 Jun 2026, 6:10 PM",
    amount: "RM12.50",
    subtotal: "RM11.50",
    serviceFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Green Bowl - Kuching",
    pickupCode: "1934",
    remarks: "Pending vendor preparation.",
    items: [{ name: "Healthy Rice Bowl", qty: 1, price: "RM11.50", total: "RM11.50" }],
    timeline: [
      ["Order Created", "28 Jun 2026, 6:10 PM"],
      ["Payment Successful", "28 Jun 2026, 6:12 PM"],
    ],
  },
  "SB-10082": {
    orderNo: "SB-10082",
    vendor: "Daily Bakery",
    customer: "Mei Ling",
    phone: "016-9988776",
    email: "meiling@example.com",
    status: "Collected",
    paymentStatus: "Paid",
    paymentMethod: "2C2P E-Wallet",
    collectionTime: "Today, 5:30 PM",
    orderTime: "28 Jun 2026, 4:45 PM",
    amount: "RM9.90",
    subtotal: "RM8.90",
    serviceFee: "RM1.00",
    discount: "RM0.00",
    outlet: "Daily Bakery - Miri",
    pickupCode: "5580",
    remarks: "Collected by customer.",
    items: [{ name: "Assorted Bread Set", qty: 1, price: "RM8.90", total: "RM8.90" }],
    timeline: [
      ["Order Created", "28 Jun 2026, 4:45 PM"],
      ["Payment Successful", "28 Jun 2026, 4:46 PM"],
      ["Ready for Collection", "28 Jun 2026, 5:10 PM"],
      ["Collected", "28 Jun 2026, 5:28 PM"],
    ],
  },
};

const statusClass = (value) => String(value).toLowerCase().replace(/\s+/g, "-");

const InfoItem = ({ label, value }) => (
  <div className="order-detail__info-item">
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

const OrderDetailPage = () => {
  const navigate = useNavigate();
  const { orderNo } = useParams();
  const order = orderDetails[orderNo] || orderDetails["SB-10084"];

  return (
    <div className="order-detail">
      <section className="order-detail__header">
        <div>
          <button className="order-detail__back" type="button" onClick={() => navigate("/admin/orders")}>
            ← Back to Orders
          </button>
          <p className="order-detail__eyebrow">SecondBite Admin</p>
          <h2>Order {order.orderNo}</h2>
          <p>Review order details, customer information, payment status, and collection progress.</p>
        </div>

        <div className="order-detail__header-actions">
          <span className={`order-detail__status order-detail__status--${statusClass(order.status)}`}>
            {order.status}
          </span>
          <button type="button">Print Receipt</button>
        </div>
      </section>

      <section className="order-detail__summary-grid">
        <InfoItem label="Customer" value={`${order.customer} / ${order.phone}`} />
        <InfoItem label="Vendor" value={order.vendor} />
        <InfoItem label="Collection Time" value={order.collectionTime} />
        <InfoItem label="Total Amount" value={order.amount} />
      </section>

      <section className="order-detail__content-grid">
        <div className="order-detail__panel order-detail__panel--wide">
          <div className="order-detail__panel-title">
            <h3>Order Items</h3>
            <p>Static MVP UI sample. Connect API later.</p>
          </div>

          <div className="order-detail__items">
            <div className="order-detail__items-head">
              <span>Item</span>
              <span>Qty</span>
              <span>Price</span>
              <span>Total</span>
            </div>
            {order.items.map((item) => (
              <div className="order-detail__items-row" key={item.name}>
                <strong>{item.name}</strong>
                <span>{item.qty}</span>
                <span>{item.price}</span>
                <span>{item.total}</span>
              </div>
            ))}
          </div>

          <div className="order-detail__totals">
            <div><span>Subtotal</span><strong>{order.subtotal}</strong></div>
            <div><span>Service Fee</span><strong>{order.serviceFee}</strong></div>
            <div><span>Discount</span><strong>{order.discount}</strong></div>
            <div className="order-detail__grand-total"><span>Grand Total</span><strong>{order.amount}</strong></div>
          </div>
        </div>

        <div className="order-detail__panel">
          <div className="order-detail__panel-title">
            <h3>Payment</h3>
          </div>
          <InfoItem label="Payment Status" value={order.paymentStatus} />
          <InfoItem label="Payment Method" value={order.paymentMethod} />
          <InfoItem label="Order Time" value={order.orderTime} />
          <InfoItem label="Pickup Code" value={order.pickupCode} />
        </div>

        <div className="order-detail__panel">
          <div className="order-detail__panel-title">
            <h3>Customer & Pickup</h3>
          </div>
          <InfoItem label="Customer Email" value={order.email} />
          <InfoItem label="Outlet" value={order.outlet} />
          <InfoItem label="Remarks" value={order.remarks} />
        </div>

        <div className="order-detail__panel order-detail__panel--wide">
          <div className="order-detail__panel-title">
            <h3>Order Timeline</h3>
          </div>
          <div className="order-detail__timeline">
            {order.timeline.map(([title, time]) => (
              <div className="order-detail__timeline-item" key={`${title}-${time}`}>
                <span />
                <div>
                  <strong>{title}</strong>
                  <p>{time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderDetailPage;
